import React from 'react';
import Header from '../components/Header';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

function FAQPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <FAQ />
      </div>
      <Footer />
    </>
  );
}

export default FAQPage;
